export const VirtualSearchFilterInputs = {
  SELECT: 'select',
  DATE: 'date',
  BOOLEAN: 'boolean',
  TEXT: 'text',
} as const;

export const VIRTUAL_SORT_TYPE = {
  ASC: 'asc',
  DESC: 'desc',
} as const;
